import {Component, Inject} from '@angular/core';
import {FinancialFact} from './claims-table.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {formatCurrency} from '@angular/common';

@Component({
  selector: 'app-detail-table',
  templateUrl: './claims-financial-fact.component.html',
  styleUrls: ['../../detail-screen/detail-screen.component.css'],
})

export class ClaimsFinancialFactComponent {
  restrictedData: boolean;
  emptyValuePlaceholder = '-';
  title = 'Afwikkeling vordering';
  tableColumns: string[];
  tableData: FinancialFact[];
  errorText: string;
  showTable = true;

  constructor(public dialogRef: MatDialogRef<ClaimsFinancialFactComponent>,
              @Inject(MAT_DIALOG_DATA) public data: FinancialFact[]) {
    this.tableColumns = ['claimAmount', 'mutationAmount', 'mutationReason', 'processingDate', 'outstandingClaimAmount'];
    this.tableData = data;
    if (this.tableData === undefined || this.tableData.length === 0 ) {
      this.errorText = 'Er zijn geen gegevens over de afwikkeling van de vordering beschikbaar.';
      this.showTable = false;
    }
  }

  getAmount(value, currency: string) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatCurrency(value, 'nl', '€', currency);
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

}
